export default __webpack_public_path__ + "static/media/levieuxalbert.9c1cb12c.svg";